import {
  fetchContent,
  postNullContent,
  wrapPromise,
} from "../../lib/fetchData";
import { SuspendPromise } from "../../lib/react-utils";
import { ICartReadContext } from "./cart-read-context";

export function getCart(): Promise<ShoppingCart> {
  return fetchContent("/api/Cart/GetCart");
}

export function adjustCartItem(request: CartItemRequest): Promise<string> {
  return postNullContent<CartItemRequest>("/api/Cart/UpdateCart", request);
}

/**
 * Add an item to the current cart (send API call)
 * @param request
 * @returns
 */
export function addItemToCart(request: CartItemRequest): Promise<string> {
  return postNullContent<CartItemRequest>("/api/Cart/AddItem", request);
}


export function fetchCartData(): SuspendPromise<ShoppingCart> {
  const url = `/api/Cart/GetCart`;

  return wrapPromise(fetchContent<ShoppingCart>(url));
}

export const ApiContext: ICartReadContext = {
  GetCart: getCart,
};
